module.exports = __webpack_public_path__ + "img/trust-bg.27533d30.svg";